import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import { ReactReduxContext } from 'react-redux'

import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

import DropZone from 'components/Shared/DropZone';
import LoadingButton from 'components/Shared/LoadingButton';
import InfoSuiviColis from 'components/Shared/InfoSuiviColis';
import MyRadioGroup from 'components/Shared/MyRadioGroup';
import MessageDialog from 'components/Shared/MessageDialog';
import AdresseForm from 'components/Shared/AdresseForm';


import PieceGestionSearch from 'components/Shared/PieceGestionSearch';
import { AdresseFormModes } from 'components/Shared/AdresseForm';

import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
//import { TypeCodes } from 'constants.js';

import DemandeEnlevement from './QualificationComponents/DemandeEnlevement';



import enlevementHelper from 'utils/enlevementHelper';


const pieceGestionFormat = new RegExp("^[PLpl]\\d{10,12}$");  // A mettre en constante


const Etapes = {
    ChoixPiece: 0,
    PieceExistante: 1,
    ChangementDAdresse: 2
};

const ReponseCodes = {
    Inconnue: 0, // Mais on enverra une 404
    MauvaisClient: 1,
    PieceExistante: 2,
    ChangementDAdressePossible: 3,
    ChangementDAdresseImpossible: 4
};


/* Liste des réponses possibles */
const etatLivraisonLabel = "Quel est l'état de livraison de la commande ? ";
const etatLivraisonLabels = [
    "La commande a été livrée et se trouve chez le client.",
    "La commande est en cours d'acheminement."
];


// Obtention d'une chaine depuis un object d'adresse
const adrToStr = (adr) => {

    let result = '';
    if (adr.adresseNom) {
        result += adr.adresseNom + '\n';
    }
    if (adr.adresse1) {
        result += adr.adresse1 + '\n';
    }
    if (adr.adresse2) {
        result += adr.adresse2 + '\n';
    }
    result += adr.codePostal + ' ' + adr.ville;

    return result;
};



const DemandeChangementAdresseStep = ({ reclamation, onChange, onSelectPiece, onDetailsOveride, onNextStepValid }) => {

    const { store } = React.useContext(ReactReduxContext);

    const [expandedPanels, setExpandedPanels] = React.useState([true, true]);
    const [etape, setEtape] = React.useState(0);

    const [numeroPreparation, setNumeroPreparation] = React.useState(''); // Pour le textField du choix de la pièce
    const [pieceErreur, setPieceErreur] = React.useState(false);
    const [pieceMessage, setPieceMessage] = React.useState('Sélectionner une pièce');

    const [fetchingPiece, setFetchingPiece] = React.useState(false);

    const [pieceGestion, setPieceGestion] = React.useState(null);  // Si on a trouvé une pièce gestion

    const [rechercheErreur, setRechercheErreur] = React.useState('');

    const [searchDisabled, setSearchDisabled] = React.useState(true);


    // Etape PieceExistante
    const [etatLivraison, setEtatLivraison] = React.useState(''); // Pour détail de qualification
    const [commentaireLivraison, setCommentaireLivraison] = React.useState(''); // Pour détail de qualification
    const [enlevement, setEnlevement] = React.useState(null); 

    // Etape PieceExistante ou ChangementDAdressePossible
    const [adresseVerrouille, setAdresseVerrouille] = React.useState(null);

    // Etape ChangementDAdressePossible
    const [nouvelleAdresse, setNouvelleAdresse] = React.useState('');
    const [plateforme, setPlateforme] = React.useState('');




    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !searchDisabled) {
            setFetchingPiece(true);
        }
    };


    // Au montage
    React.useEffect(() => {

        onNextStepValid(false);

    }, []);


    // Contrôle du format du numéro de préparation
    React.useEffect(
        () => {

            var check = pieceGestionFormat.test(numeroPreparation);

            if (check) {
                setPieceErreur(false);
                setPieceMessage('');
                setSearchDisabled(false);
            }
            else {
                setSearchDisabled(true);
                if (numeroPreparation.length < 4) {
                    setPieceErreur(false);
                    setPieceMessage('Sélectionner une pièce');
                }
                else {
                    setPieceErreur(true);
                    setPieceMessage('Format de pièce incorrect : P ou L + 11 chiffres');
                }
            }

            setRechercheErreur('');
            setAdresseVerrouille(null);

        },
        [numeroPreparation]
    );


    // Fetch de la préparation
    React.useEffect(() => {
        const fetchData = async () => {

            axios.get(`api/pieces-gestion/${numeroPreparation}/infos-plateformes-logistique?codeClient=${reclamation.client.code}`)
                .then((response) => {

                    //console.log(response);

                    switch (response.data.resultCode) {
                        case ReponseCodes.PieceExistante:
                            {
                                setPieceGestion({ numeroPreparation, ...response.data });

                                onSelectPiece( response.data.numeroPiece, [{ key: ReclamationQualificationDetailCodes.EtatLivraison, errorMsg: etatLivraisonLabel }], false);

                                setExpandedPanels([false, false]);

                                setEtape(Etapes.PieceExistante);
                                break;
                            }
                        case ReponseCodes.ChangementDAdressePossible:
                            {
                                setAdresseVerrouille({ ...response.data.adresseLivraison });

                                setExpandedPanels([false, false]);
                                setPlateforme(response.data.plateforme);

                                setEtape(Etapes.ChangementDAdresse);
                                break;
                            }
                        case ReponseCodes.MauvaisClient:
                        case ReponseCodes.ChangementDAdresseImpossible:
                            {
                                setRechercheErreur(response.data.erreurMessage);
                                setSearchDisabled(true);
                                setPieceErreur(true);
                                setPieceMessage('Entrez un nouveau numéro de préparation');

                                setAdresseVerrouille({ ...response.data.adresseLivraison });

                                break;
                            }
                        case ReponseCodes.Inconnue: // 404 
                        default:
                            {
                                setRechercheErreur(response.data.erreurMessage);
                                setSearchDisabled(true);
                                setPieceErreur(true);
                                setPieceMessage('Entrez un nouveau numéro de préparation');
                                break;
                            }

                    }
                })
                .catch((error) => {

                    console.log(error.response.status);

                    if (error.response.status === 404) {

                        console.log(error.response.data);

                        if (error.response.data.erreurMessage) {
                            setRechercheErreur(error.response.data.erreurMessage);
                            setSearchDisabled(true);
                            setPieceErreur(true);
                            setPieceMessage('Entrez un nouveau numéro de préparation');
                        }

                    }
                    else if (error.status === 500) {
                        // Erreur à remonter aux admins : notification si possible
                    }
                    else {

                        console.log(error);
                    }

                })
                .then(() => {
                    // always executed
                    setFetchingPiece(false);
                });
        };

        if (fetchingPiece) {
            fetchData();
        }
    }, [fetchingPiece]);



    // Erreurs et qualification details
    React.useEffect(() => {

        //console.log({ etape, etatLivraison, commentaireLivraison, nouvelleAdresse, enlevement });
                
        let errors = getErrors();

        if (errors.length > 0) {

            //console.log("errors", errors);

            onDetailsOveride([], errors);
            return;
        }

        console.log("NO errors");

        let detailsToAdd = [];

        // Pas d'erreur, on peut rajouter les détails de qualification
        switch (etape) {
            case Etapes.PieceExistante:
                {
                    detailsToAdd.push({
                        code: ReclamationQualificationDetailCodes.EtatLivraison,
                        type: ReclamationQualificationDetailType.ChoixSimple,
                        libelle: etatLivraisonLabel,
                        valeurInteger: etatLivraison,
                        valeurString: etatLivraisonLabels[etatLivraison]
                    });

                    if (commentaireLivraison) {
                        detailsToAdd.push({
                            code: ReclamationQualificationDetailCodes.CommentaireClient,
                            type: ReclamationQualificationDetailType.Texte,
                            libelle: "Commentaire sur la livraison",
                            valeurString: commentaireLivraison
                        });
                    }

                    // Demande d'enlèvement
                    if (etatLivraison === 0) {
                        // Il faut récuperer les détails de l'enlèvement

                        let detailsEnlevement = enlevementHelper.toQualificationDetails(enlevement);
                        detailsToAdd.push(...detailsEnlevement);

                    }

                    // Changement d'adresse
                    if (etatLivraison === 1)
                    {
                        detailsToAdd.push({
                            code: ReclamationQualificationDetailCodes.AdresseDestination,
                            type: ReclamationQualificationDetailType.Texte,
                            libelle: "Adresse de livraison",
                            valeurString: adrToStr(pieceGestion.adresseLivraison)
                        });

                        detailsToAdd.push({
                            code: ReclamationQualificationDetailCodes.AdresseDestinationNouvelle,
                            type: ReclamationQualificationDetailType.Texte,
                            libelle: "Nouvelle adresse de livraison",
                            valeurString: nouvelleAdresse
                        });
                    }

                    break;
                }
            case Etapes.ChangementDAdresse:
                {
                    detailsToAdd.push({
                        code: ReclamationQualificationDetailCodes.NumeroPreparation,
                        type: ReclamationQualificationDetailType.Texte,
                        libelle: "Numéro de préparation",
                        valeurString: numeroPreparation
                    });

                    detailsToAdd.push({
                        code: ReclamationQualificationDetailCodes.AdresseDestination,
                        type: ReclamationQualificationDetailType.Texte,
                        libelle: "Adresse de livraison",
                        valeurString: adrToStr(adresseVerrouille)
                    });

                    detailsToAdd.push({
                        code: ReclamationQualificationDetailCodes.AdresseDestinationNouvelle,
                        type: ReclamationQualificationDetailType.Texte,
                        libelle: "Nouvelle adresse de livraison",
                        valeurString: nouvelleAdresse
                    });

                    break;
                }
            case Etapes.ChoixPiece: // Forcément en erreur
            default:
                break;
        }

        console.log("overriding details : ", detailsToAdd, errors);

        onDetailsOveride(detailsToAdd, errors);


    }, [etape, etatLivraison, commentaireLivraison, nouvelleAdresse, enlevement]);



    const getErrors = () => {

        let errors = [];


        switch (etape) {
            case Etapes.ChoixPiece:
                {
                    errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: "Veuillez sélectionner une pièce." });
                    break;
                }
            case Etapes.PieceExistante:
                {
                    if (etatLivraison === '')
                    {
                        errors.push({ key: ReclamationQualificationDetailCodes.EtatLivraison, errorMsg: etatLivraisonLabel });
                    }
                    else
                    {
                        if (etatLivraison === 0)  // La commande a été livrée et se trouve chez le client.
                        {
                            let validation = enlevementHelper.isValid(enlevement);

                            console.log('validation', validation);
                            if (!validation.valid)
                            {
                                errors.push({ key: "Enlevement", errorMsg: validation.errorMsg });
                            }

                        }

                        if (etatLivraison === 1)  // La commande est en cours d'acheminement.
                        {
                            if (nouvelleAdresse === '')
                            {
                                errors.push({ key: ReclamationQualificationDetailCodes.AdresseDestinationNouvelle, errorMsg: "Veuillez saisir la nouvelle adresse de destination" });
                            }
                        }
                    }
                    break;
                }
            case Etapes.ChangementDAdresse:
                {
                    if (nouvelleAdresse === '')
                    {
                        errors.push({ key: ReclamationQualificationDetailCodes.AdresseDestinationNouvelle, errorMsg: "Veuillez saisir la nouvelle adresse de destination" });
                    }
                    break;
                }
            default:
                break;
        }


        return errors;
    };

    const handleChange = (event) => {

        let errors = getErrors();

        onChange(event, errors);

    };


    const handleSelectPiece = (numeroPiece) => {

        onSelectPiece(numeroPiece, [{ key: ReclamationQualificationDetailCodes.EtatLivraison, errorMsg: etatLivraisonLabel }], false);

        let pieceComplete = store.getState().pieceGestion['addReclamation'].piecesGestion.items.find(x => x.numeroPiece === numeroPiece);

        setPieceGestion(pieceComplete);

        setExpandedPanels([false, false]);

        setEtape(Etapes.PieceExistante);
    };

    return (
        <Stack spacing={1} sx={{ backgroundColor: '' }}>

            <TextField
                multiline
                fullWidth
                name="commentaire"
                label="Commentaire"
                placeholder="Décrire le problème rencontré"
                maxRows="3"
                onChange={handleChange}
                value={reclamation.commentaire}
                InputLabelProps={{
                    shrink: true
                }}
            />

            <DropZone id="fichiersIds" name="fichiersIds" onChange={handleChange} />


            <Accordion
                expanded={expandedPanels[0]}
                onChange={() => { setExpandedPanels([!expandedPanels[0], expandedPanels[1]]); }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography >Rechercher une pièce expédiée*</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <PieceGestionSearch
                        onSelectPiece={handleSelectPiece}
                        client={reclamation.client}
                        withLignes={false}
                        namespace={"addReclamation"}
                        warningReclamation
                        defautProduitInfos={false}
                        logistiqueInfos={false}
                        defautNumeroPiece={reclamation.numeroPiece}
                        cacherTableResultat={true}
                        autoriserToutePieceDuJour={true}
                    />
                </AccordionDetails>
            </Accordion>


            <Accordion
                expanded={expandedPanels[1]}
                onChange={() => { setExpandedPanels([expandedPanels[0], !expandedPanels[1]]); }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography>Rechercher une pièce en préparation*</Typography>
                </AccordionSummary>
                <AccordionDetails>

                    <Stack m={1} spacing={1} direction={"row"} sx={{ alignItems: "start" }}>
                        <TextField
                            sx={{ width: '410px' }}
                            name="numeroPiece"
                            label="Recherche de pièce en préparation"
                            placeholder="Indiquez le numéro de P"
                            onChange={(e) => { setNumeroPreparation(e.target.value) }}
                            value={numeroPreparation}
                            InputLabelProps={{
                                shrink: true
                            }}
                            error={pieceErreur}
                            helperText={pieceMessage}
                            disabled={etape !== Etapes.ChoixPiece}
                            onKeyDown={handleKeyDown}
                        />

                        {etape === Etapes.ChoixPiece && (
                            <LoadingButton
                                disabled={searchDisabled}
                                onClick={() => { setFetchingPiece(true); }}
                                pending={fetchingPiece}
                                label={"Rechercher"}
                                mode={"loupe"}
                            />
                        )}
                    </Stack>

                    {etape === Etapes.ChoixPiece && (
                        <>

                            <span>{rechercheErreur.split("\n").map((x, i) => (<p key={i}>{x}</p>))}</span>

                            {adresseVerrouille && (

                                <fieldset style={{ borderRadius: '8px', width: '410px' }}>
                                    <legend>Adresse de livraison</legend>
                                    <p>{adresseVerrouille.adresse1}</p>
                                    <p>{adresseVerrouille.adresse2}</p>
                                    <p>{adresseVerrouille.codePostal} {adresseVerrouille.ville}</p>
                                </fieldset>

                            )}

                        </>
                    )}

                </AccordionDetails>
            </Accordion>


            {etape === Etapes.PieceExistante && (


                <Paper sx={{ backgroundColor: '' }}>
                    <Stack m={1} spacing={1}>

                        <p>Concerne la pièce <span style={{ fontWeight: 'bold' }}>{pieceGestion.numeroPiece} - {pieceGestion.numeroPreparation}</span></p>

                        <fieldset style={{ borderRadius: '8px', width: '410px', flexShrink: 0 }}>
                            <legend>Adresse de livraison</legend>
                            <p>{pieceGestion.adresseLivraison.nomLivraison}</p>
                            <p>{pieceGestion.adresseLivraison.adresse1}</p>
                            <p>{pieceGestion.adresseLivraison.adresse2}</p>
                            <p>{pieceGestion.adresseLivraison.codePostal} {pieceGestion.adresseLivraison.ville}</p>
                        </fieldset>

                        <fieldset style={{ borderRadius: '8px', width: '410px', flexShrink: 0 }}>
                            <legend>Suivi colis</legend>
                            <InfoSuiviColis piece={pieceGestion} />
                        </fieldset>



                        <MyRadioGroup
                            value={etatLivraison}
                            label={etatLivraisonLabel}
                            labels={etatLivraisonLabels}
                            onChange={newValue => { setEtatLivraison(newValue); }}
                        />


                        <TextField
                            fullWidth
                            label="Commentaire sur la livraison"
                            placeholder="Vous pouvez saisir un commentaire sur la livraison ..."
                            onChange={(e) => { setCommentaireLivraison(e.target.value) }}
                            value={commentaireLivraison}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />


                        {etatLivraison === 1 && (
                            <AdresseForm
                                onChange={(a) => { setNouvelleAdresse(a.adresse); }}
                                label={"Nouvelle adresse de livraison"}
                                mode={AdresseFormModes.Basique}
                                autoFocus={true}
                            />
                        )}


                    </Stack>
                </Paper>

            )}




            {etape === Etapes.ChangementDAdresse && (

                <Paper sx={{ backgroundColor: '' }}>
                    <Stack m={1} spacing={1}>

                        <MessageDialog
                            titre="Avertissement"
                            contenu={"Attention, commande en préparation. Le changement d'adresse de livraison ne pourra être transmis au transporteur que le lendemain.\nAucune action ne sera possible si, demain, la commande est en cours de livraison."}
                            ouvert={true}
                            texteOK="OK"
                        />


                        <p>La préparation <span style={{ fontWeight: 'bold' }}>{numeroPreparation}</span> a été trouvée sur la plateforme logistique <span style={{ fontWeight: 'bold' }}>{plateforme}</span>.</p>


                        <Stack direction={"row"}>

                            <fieldset style={{ borderRadius: '8px', width: '410px', flexShrink: 0 }}>
                                <legend>Adresse de livraison</legend>
                                <p>{adresseVerrouille.adresseNom}</p>
                                <p>{adresseVerrouille.adresse1}</p>
                                <p>{adresseVerrouille.adresse2}</p>
                                <p>{adresseVerrouille.codePostal} {adresseVerrouille.ville}</p>
                            </fieldset>


                            <AdresseForm
                                onChange={(a) => { setNouvelleAdresse(a.adresse); }}
                                label={"Nouvelle adresse de livraison"}
                                mode={AdresseFormModes.Basique}
                                autoFocus={true}
                            />

                        </Stack>

                    </Stack>
                </Paper>

            )}


            {etatLivraison === 0 && (
                <DemandeEnlevement piece={pieceGestion} onChange={(_enlevement) => { setEnlevement(_enlevement); }} />
            )}


        </Stack>
    );
}


DemandeChangementAdresseStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDetailsOveride: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    validationErrors: PropTypes.array,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
};

export default DemandeChangementAdresseStep;